import { ShopifyShopData } from 'models/ShopifyShopData';

export const GET_SHOP_DATA_QUERY = /* GraphQL */ `
    query GetShopData {
        shop {
            id
            name
            currencyCode
            checkoutApiSupported
            billingAddress {
                countryCodeV2
            }
            plan {
                displayName
                partnerDevelopment
                shopifyPlus
            }
        }
    }
`;

export interface GetShopDataResponse {
    shop: {
        id: string;
        name: string;
        currencyCode: string;
        checkoutApiSupported: boolean;
        billingAddress: {
            countryCodeV2: string;
        };
        plan: {
            displayName: string;
            partnerDevelopment: boolean;
            shopifyPlus: boolean;
        };
    };
}

/**
 * Maps the GraphQL shop payload onto the shape the app already consumes, previously served by
 * the `/shop-data` and `/shop-plan-info` backend endpoints.
 *
 * The Admin GraphQL API has no counterpart for the REST `plan_name` slug, so `plan_name` and
 * `shop_plan.displayName` both come from `plan.displayName`.
 */
export function mapShopData(response?: GetShopDataResponse): ShopifyShopData | undefined {
    const shop = response?.shop;
    if (!shop) {
        return undefined;
    }

    return {
        shop: {
            currency: shop.currencyCode,
            plan_name: shop.plan?.displayName,
            country: shop.billingAddress?.countryCodeV2,
        },
        shop_plan: {
            displayName: shop.plan?.displayName,
            partnerDevelopment: shop.plan?.partnerDevelopment,
            shopifyPlus: shop.plan?.shopifyPlus,
            checkoutApiSupported: shop.checkoutApiSupported,
        },
    };
}
